import * as authSelectors from "../auth/authSelectors";
import { RootState } from "../../store";

export const venueForEdit = (state: RootState) => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  return venueRecord?.venueToEdit;
};

export const editFormErrors = (state: RootState) => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  if (!venueRecord) {
    return null;
  }

  return venueRecord.errors;
};

export const isLoadingVenues = (state: RootState): boolean => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  if (!venueRecord) {
    return false;
  }

  return venueRecord.isLoadingVenues;
};

export const isLoadingVenue = (state: RootState): boolean => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  return venueRecord?.isLoadingVenue || false;
};

export const isUpsertingVenue = (state: RootState): boolean => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  if (!venueRecord) {
    return false;
  }

  return venueRecord?.isUpsertingVenue || false;
};

export const isDeletingVenueImage = (
  state: RootState,
  imageUrl: string
): boolean => {
  const organization = authSelectors.selectedOrganizationKeyName(state);
  const venueRecord = state.venue.org[organization];

  if (!venueRecord) {
    return false;
  }

  return !!venueRecord?.isDeletingVenueImage?.[imageUrl];
};
